import React, { ReactElement, useContext, useEffect, useState } from "react";
import { Bars } from "react-loader-spinner";
import {
  Box,
  Button,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import {
  House,
  BusinessCenter,
  School,
  TravelExplore,
  Flag as FlagIcon,
  MonitorHeart as MonitorHeartIcon,
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";
import { authContext } from "../Context/Authentication/authContext";
import splashImage from "../assets/splash1.jpeg";
import MapIcon from "../assets/Geography-Splash.png";
import "./Growth_Prediction.scss";
import Chat from "../Chat1/Chat";
import ModestoChat from "../Chat1/ModestoChat";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";
import axios from "axios";
import { baseURL, dataScienceURL } from "../config";
import {
  BootstrapDialog,
  BootstrapDialogTitle,
} from "../CityAttractions/CityAttractions";
import { number } from "@amcharts/amcharts4/core";

let selectedCity = [];

// @ts-ignore
const Growth_Prediction = (props: any): ReactElement => {
  const [growthType, setGrowthType] = useState("extreme_high_growth");
  const [categoryGrowth, setCategoryGrowth] = useState<any>([]);
  const [city, setCity] = useState<any>({});
  const [isOpen, setOpen] = useState(false);
  const [year, setyear] = useState("1");
  const { state, dispatch }: any = useContext(authContext);
  const [attractionData, setAttractionData]: any = useState({});
  const [isLoading, setLoading]: any = useState(false);
  const [states, setStates]: any = React.useState([]);
  const navigate = useNavigate();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  useEffect(() => {
    if (!state?.filters.states) {
      getStates();
    } else {
      setStates(state?.filters.states);
    }
  }, [state?.filters?.states]);
  const getStates = async () => {
    try {
      const response = await axios.get(`${baseURL}getState`);
      if (response.data?.length) {
        let temp = response.data?.map((item: any) => {
          return {
            name: item.state,
            coOrd: {
              lat: item.latitude,
              lng: item.longitude,
            },
            abbr: item.abbr,
          };
        });
        setStates(temp);
        let filters = state.filters;
        filters.state = temp[0].name;
        dispatch({
          type: "APPLY_FILTER",
          payload: {
            ...filters,
            states: temp,
            stateCord: temp[0],
            selectedTerritory: temp[0].name,
            state: temp[0].name,
          },
        });
      } else {
        setStates([]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const getExtremePrediction = () => {
    switch (year) {
      case "1/2":
        return "(>=10.0)";
      case "1":
        return "(>=20.0)";
      case "2":
        return "(>=40.0)";
      case "3":
        return "(>=60.0)";
      case "4":
        return "(>=80.0)";
      case "5":
        return "(>=100.0)";
    }
  };
  const getHighPrediction = () => {
    switch (year) {
      case "1/2":
        return "(>5.0 and <10.0)";
      case "1":
        return "(>10.0 and <20.0)";
      case "2":
        return "(>20.0 and <40.0)";
      case "3":
        return "(>30.0 and <60.0)";
      case "4":
        return "(>40.0 and <80.0)";
      case "5":
        return "(>50.0 and <100.0)";
    }
  };
  const getModeratePrediction = () => {
    switch (year) {
      case "1/2":
        return "(<5.0 and >0)";
      case "1":
        return "(<10.0 and >0)";
      case "2":
        return "(<20.0 and >0)";
      case "3":
        return "(<30.0 and >0)";
      case "4":
        return "(<40.0 and >0)";
      case "5":
        return "(<50.0 and >0)";
    }
  };
  const getLowPrediction = () => {
    switch (year) {
      case "1/2":
        return "(<5.0 and >0)";
      case "1":
        return "(<10.0 and >0)";
      case "2":
        return "(<20.0 and >0)";
      case "3":
        return "(<30.0 and >0)";
      case "4":
        return "(<40.0 and >0)";
      case "5":
        return "(<50.0 and >0)";
    }
  };
  const predictionGrowth = [
    { id: "0", name: "Growth Predictions", value: "Growth Predictions" },
    {
      id: "1",
      name: "Growth" + `${getExtremePrediction()}`,
      value: "extreme_high_growth",
    },
    {
      id: "2",
      name: "Growth" + `${getHighPrediction()}`,
      value: "high_growth",
    },
    {
      id: "3",
      name: "Growth" + `${getModeratePrediction()}`,
      value: "moderate_growth",
    },
    {
      id: "4",
      name: "Growth" + "(<=0)",
      value: "low_growth",
    },
  ];

  useEffect(() => {
    getCategoryGrowth();
  }, [year, state.filters.state]);

  const getAttractionText = (data: any) => {
 
    if (Object.keys(data).length) {
      return (
        <div className="popup-subtext">
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            className="popup-margin"
            style={{ marginBottom: "10px" }}
          >
            <div
              className="info-container"
              style={{ width: "100%", float: "right" }}
            >
              <span
                className="more-info"
                onClick={handleCityHistoryClick}
                style={{
                  fontSize: "18px",
                  // cursor: "pointer",
                  padding: "0.2rem 1rem",
                  width: "fit-content",
                  color: "white",
                  float: "right",
                  cursor: "pointer",
                  fontWeight: "bolder",
                }}
              >
                Click here for more Real Estate Statistics
              </span>
              {/* <Button
                variant="contained"
                style={{
                  fontSize: "0.8rem",
                  // cursor: "pointer",
                  padding: "0.2rem 1rem",
                  backgroundColor: "#1976d2",
                  width: "fit-content",
                  marginTop: "2rem",
                  color: "white",
                  float: "right",
                }}
                onClick={handleCityHistoryClick}
              >
                City History
              </Button> */}
            </div>
            {city.lastYearHomesales && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="lastYearHomesales"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  {currentYear - 1} Home Sales:
                </span>
                <br />
                {city.lastYearHomesales + '$'}
                <br />
              </Grid>
            )}
            {city.lastTwoYearHomesales && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="lastTwoYearHomesales"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  {currentYear - 2} Home Sales
                </span>
                <br />
                {city.lastTwoYearHomesales + '$'}
                <br />
              </Grid>
            )}
            {city.lastThreeYearHomesales && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="lastThreeYearHomesales"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  {currentYear - 3} Home Sales
                </span>
                <br />
                {city.lastThreeYearHomesales + '$'} 
                <br />
              </Grid>
            )}
            {city.lastYearMspGrowth && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="lastYearMspGrowth"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  {currentYear - 1} MSP Growth:
                </span>
                <br />
                {city.lastYearMspGrowth + "%"}
                <br />
              </Grid>
            )}
            {city.lastTwoYearMspGrowth && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="lastTwoYearMspGrowth"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  {currentYear - 2} Year MSP Growth:
                </span>
                <br />
                {city.lastTwoYearMspGrowth + "%"}
                <br />
              </Grid>
            )}
            {city.lastThreeYearMspGrowth && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="lastThreeYearMspGrowth"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  {currentYear - 3} Year MSP Growth:
                </span>
                <br />
                {city.lastThreeYearMspGrowth + "%"}
                <br />
              </Grid>
            )}
          </Grid>
          <div>
            <span className="popup-subtext-heading">History:</span>
            <br />
            {data.history}
          </div>
          {data.attractions && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">Attractions:</span>
              <br />
              {data.attractions}
            </div>
          )}
          {data.things_to_do && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">Things To Do:</span>
              <br />
              {data.things_to_do}
            </div>
          )}
          {data.nearby_cities && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">Nearby Cities:</span>
              <br />
              {data.nearby_cities}
            </div>
          )}
          {data.higher_education_institutions && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">
                Higher Education Institutions:
              </span>
              <br />
              {data.higher_education_institutions}
            </div>
          )}
          {data.attraction_parks && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">Attraction Parks:</span>
              <br />
              {data.attraction_parks}
            </div>
          )}
          {data.stadiums && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">Stadiums:</span>
              <br />
              {data.stadiums}
            </div>
          )}
          {data.museums && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">Museums:</span>
              <br />
              {data.museums}
            </div>
          )}
          {data.beaches && data.beaches !== "NA" && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">Beaches:</span>
              <br />
              {data.beaches}
            </div>
          )}
          {data.major_companies && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">Major Companies:</span>
              <br />
              {data.major_companies}
            </div>
          )}
          {data.sports_recreational_activities && (
            <div className="popup-margin">
              <span className="popup-subtext-heading">
                Sports Recreational Activities:
              </span>
              <br />
              {data.sports_recreational_activities}
            </div>
          )}

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            className="popup-margin"
          >
            {data.average_commute_time && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="average_commute_time"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  Average Commute Time:
                </span>
                <br />
                {data.average_commute_time}
                <br />
              </Grid>
            )}
            {data.violent_crime_rate && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="Property_Crime_Rate"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  Violent Crime Rate:
                </span>
                <br />
                {data.violent_crime_rate}
                <br />
              </Grid>
            )}
            {data.property_crime_rate && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="Property_Crime_Rate"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">
                  Property Crime Rate:
                </span>
                <br />
                {data.property_crime_rate}
                <br />
              </Grid>
            )}
            {data.happiness_index && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="happiness_index"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">Happiness Index:</span>
                <br />
                {data.happiness_index}
                <br />
              </Grid>
            )}
            {data.temperature && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="temperature"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">Temperature:</span>
                <br />
                {data.temperature}
                <br />
              </Grid>
            )}
            {data.crime_index && (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                key="crime_index"
                className="popup-text-center"
              >
                <span className="popup-subtext-heading">Crime Index:</span>
                <br />
                {data.crime_index}
                <br />
              </Grid>
            )}
          </Grid>
        </div>
      );
    } else {
      return (
        <div className="popup-subtext">
          <div className="popup-margin ">
            <div className="popup-no-data">No Data Available</div>
            <br />
          </div>
        </div>
      );
    }
  };

  const getCityAttractionInfo = async (cityName: string) => {
    if (cityName) {
      const response = await axios.get(
        `${dataScienceURL}getCityAttraction?state=${state.filters.state}&city='${cityName}'`
      );
      const resp = response.data?.cube;
      const info = resp[cityName];
      if (info.length) {
        setAttractionData(info[0]);
      } else {
        setAttractionData({});
      }
    } else {
      setAttractionData({});
    }
  };

  // useEffect(() => {
  //   if (city.length != 0) {
  //     console.log(city);
  //     const c = city;
  //     console.log(c)
  //     // if (c) {
  //     //   getCityAttractionInfo(c);
  //     // }
  //   }
  // }, [city]);

  const getCategoryGrowth = async (typeGrowth?: string) => {
    const selectedState = state.filters.state;
    console.log(growthType);
    setLoading(true);
    try {
      const response = await axios.get(
        `${dataScienceURL}getCitiesByCategory?state=${selectedState}&category=${
          typeGrowth ? typeGrowth : growthType
        }&freq=${year}_year`
      );
      setCategoryGrowth(response.data.cube);
      console.log(response.data.cube)
      setCity(response.data.cube[0])
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const YEARLY_CITY_PREDICTION = ["1/2", "1", "2", "3", "4", "5"];

  const handleCityHistoryClick = () => {
    dispatch({
      type: "APPLY_FILTER",
      payload: {
        ...state.filters,
        city: city != null ? [city.city] : [],
        cityRedirected: true,
      },
    });
    navigate("/home");
  };

  const handleGrowthType = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    setGrowthType(value);
    getCategoryGrowth(value);
  };

  const handleCityClick = (cat: any) => {
    if (!isOpen) {
      setOpen(true);
      if (cat.city) {
        getCityAttractionInfo(cat.city);
        setCity(cat);
      }
    }
  };
  
  const handleCityHover = (cat: any) => {
    console.log(cat)
    setCity(cat)
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleYearChange = (event: SelectChangeEvent) => {
    setyear(event.target.value);
  };

  const getGrowthType = () => {
    console.log(growthType);
    console.log(city)
    const obj = predictionGrowth.find((p) => p.value === growthType);
    const regex = /\(([^)]+)\)/;
    if (obj) {
      const match = regex.exec(obj.name); // Execute the regular expression on the text
      const bracketPart = match ? match[1] : "";
      return bracketPart;
    }
    return "";
  };

  const getCities = () => {
    if (categoryGrowth) {
      return (
        <div className="city">
          {categoryGrowth.map((cat: any, index: number) => {
            return (
              <h3 onClick={() => handleCityClick(cat)} onMouseOver={()=>handleCityHover(cat)} className="city-label">
                {cat.city}
              </h3>
            );
          })}
        </div>
      );
    }
  };
  const handleStateChange = (event: SelectChangeEvent) => {
    dispatch({
      type: "APPLY_FILTER",
      payload: {
        ...state.filters,
        state: event.target.value as string,
        stateCord: states.filter(
          (s: { name: string }) => s.name === (event.target.value as string)
        )[0].coOrd,
      },
    });
  };
  return (
    <div className="growth-container">
      {/* <div className="splash cp-hero"> */}
      {/* <div className="image-container">
          <img src={splashImage} className="image" />
        </div> */}
      <div className="content-container">
        <div className="radio-container">
          <FormControl
            sx={{ m: 1, width: 600 }}
            style={{ color: "white" }}
            className="radio-form"
          >
            <RadioGroup value={growthType} onChange={handleGrowthType}>
              {predictionGrowth.map((prediction) => {
                return (
                  <FormControlLabel
                    value={prediction.value}
                    control={
                      prediction.id === "0" ? (
                        <div>
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <label style={{ fontSize: "25px" }}>
                              {prediction.name} for the period of year
                            </label>

                            <Select
                              name="heat-map-months"
                              value={year}
                              label="Select State"
                              onChange={handleYearChange}
                              size="small"
                              style={{ padding: "2px", marginLeft: "4px" }}
                            >
                              {YEARLY_CITY_PREDICTION?.map((info: any) => (
                                <MenuItem value={info} key={info}>
                                  {info}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                        </div>
                      ) : (
                        <Radio style={{ color: "#fff", fontSize: "1.6rem" }} />
                      )
                    }
                    label={prediction.id != "0" ? <span style={{ fontSize: "1.4rem" }}>{prediction.name}</span> : ""}
                    style={{ marginBottom: "20px" }}
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
        </div>
        <div className="city-container">
          {
          
            !isLoading && (
              <div className="card-container">
  

                <div className="detail-city">
                      <Typography
                        variant="h3"
                        className="value-h3"
                        style={{ fontSize: "1.17rem",marginTop:"3px " }}
                      >
                        City:
                      </Typography>
                      <label style={{marginLeft:'4px'}}>{city?city.city:""}</label>
                    </div>
                    <div className="detail-value">
                      <Typography
                        variant="h3"
                        className="value-h3"
                        style={{ fontSize: "0.97rem" }}
                      >
                        HomeSales({currentYear-1}):
                      </Typography>
                      <label style={{ marginLeft: "4px" }}>{city?city.lastYearHomesales + '$':""}</label>
                    </div>
                    <div className="detail-value">
                      <Typography
                        variant="h3"
                        className="value-h3"
                        style={{ fontSize: "0.97rem" }}
                      >
                        MSP growth({currentYear-1}):
                      </Typography>
                      <label style={{ marginLeft: "4px" }}>{city?city.lastYearMspGrowth + '%':""}</label>
                    </div> 
                 
              </div>
            )
          }
        {isLoading ? (
              <div className="homesales-main__chartContainer__isLoading">
                <Bars
                  height="400"
                  ariaLabel="bars-loading"
                  wrapperClass="tab-spinner-progress-bar"
                  visible={true}
                />
              </div>
            ) : categoryGrowth.length === 0 ? (
              <span>No Cities Found!</span>
            ) : (
              getCities())}

        </div>
      </div>

      <BootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseDialog}
        >
          {city.city}({getGrowthType()})
        </BootstrapDialogTitle>
        <DialogContent dividers>
          {getAttractionText(attractionData)}
        </DialogContent>
      </BootstrapDialog>
      {/* </div> */}
    </div>
  );
};

export default Growth_Prediction;